import CrudCustom from '../../../libs/custom/CrudCustom';

let TipeDaftarNormatif = new CrudCustom('/tipe-daftar-nominatifs');
export default TipeDaftarNormatif;
